<template>
	<div>


		<template v-if="headerShow">
			<div class="gjfw" style="margin: 0 auto;">
				<div class="gjfwTil">{{ $t('i18n_56') }}</div>
				<div class="gjfwXl" @click="gjShow = !gjShow">
					<div class="gjfwXlName" v-if="gjList.length > 0">
						{{ gjList[gjSel].label }}
					</div>
					<div class="gjfwXlJt" :style="gjShow ? 'transform: rotateX(180deg);' : 'transform: rotateX(0deg)'">
						<img src="@/assets/contact/sqzx/xljt.png" />
					</div>
					<div class="gjfwXlDw" v-if="gjShow">
						<div class="gjfwXlDwFor" :class="gjSel == index ? 'gjfwXlDwForXz' : ''"
							v-for="(item, index) in gjList" :key="index" @click.stop="goGjfw(index)">
							{{ item.label }}
						</div>
					</div>
				</div>
				<div class="gjfwDdian" v-if="gjDetail">
					<div class="gjfwDdianLeft">
						<div class="gjfwDdianLeftOne">{{ gjDetail.title }}</div>
						<div class="gjfwDdianLeftTwo">{{ gjDetail.company }}</div>
						<div class="gjfwDdianLeftThree">{{ $t('i18n_57') }}：{{ gjDetail.address }}</div>
						<div class="gjfwDdianLeftFour">{{ $t('i18n_58') }}：{{ gjDetail.phone }}</div>
					</div>
					<div class="gjfwDdianRight">
						<img :src="gjDetail.cover" v-if="gjDetail.cover" />
						<img src="@/assets/contact/sqzx/dd.png" v-else />
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="gjfw" style="margin: 0 auto;">
				<div class="gjfwTil">{{ $t('i18n_56') }}</div>
				<div class="gjfwXl" @click="gjShow = !gjShow">
					<div class="gjfwXlName" v-if="gjList.length > 0">
						{{ gjList[gjSel].label }}
					</div>
					<div class="gjfwXlJt" :style="gjShow ? 'transform: rotateX(180deg);' : 'transform: rotateX(0deg)'">
						<img src="@/assets/contact/sqzx/xljt.png" />
					</div>
					<div class="gjfwXlDw" v-if="gjShow">
						<div class="gjfwXlDwFor" :class="gjSel == index ? 'gjfwXlDwForXz' : ''"
							v-for="(item, index) in gjList" :key="index" @click.stop="goGjfw(index)">
							{{ item.label }}
						</div>
					</div>
				</div>
				<div class="gjfwDdian" v-if="gjDetail">
					<div class="gjfwDdianLeft">
						<div class="gjfwDdianLeftOne">{{ gjDetail.title }}</div>
						<div class="gjfwDdianLeftTwo">{{ gjDetail.company }}</div>
						<div class="gjfwDdianLeftThree">{{ $t('i18n_57') }}：{{ gjDetail.address }}</div>
						<div class="gjfwDdianLeftFour">{{ $t('i18n_58') }}：{{ gjDetail.phone }}</div>
					</div>
					<div class="gjfwDdianRight">
						<img :src="gjDetail.cover" v-if="gjDetail.cover" />
						<img src="@/assets/contact/sqzx/dd.png" v-else />
					</div>
				</div>
			</div>
		</template>

	</div>
</template>

<script>
import {
	get_abroad_select,
	get_abroad_service_network
} from '@/api/contact.js'
export default {
	components: {

	},
	data() {
		return {
			gjList: [],
			gjSel: 0,
			gjShow: false,
			gjDetail: {},
		}
	},
	mounted() {
		this.getGwSelList();
	},
	methods: {
		goGjfw(e) {
			this.gjSel = e
			this.gjShow = false;
			this.getGjDetail();
		},
		getGwSelList() {
			let data = {}
			get_abroad_select(data).then(res => {
				console.log(res)
				this.gjList = res.data.list;
				this.getGjDetail();
			}).catch(err => {
				console.log(err)
			})

		},
		getGjDetail() {
			let data = {
				country: this.gjList[this.gjSel].value
			}
			get_abroad_service_network(data).then(res => {
				console.log(res)
				this.gjDetail = res.data.list.length > 0 ? res.data.list[0] : {}
			}).catch(err => {
				console.log(err)
			})
		},
	}
}
</script>

<style></style>
<style scoped lang="scss">
.gjfw {
	width: 1200px;
	margin: 0 auto;
	margin-top: 117px;
	padding-bottom: 95px;

	.gjfwTil {
		font-size: 36px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #000000;
		margin-bottom: 96px;
	}

	.gjfwXl {
		width: 400px;
		padding-bottom: 18px;
		margin-bottom: 43px;
		border-bottom: 2px solid #ADADAD;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-between;
		cursor: pointer;

		.gjfwXlName {
			font-size: 24px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #000000;
		}

		.gjfwXlJt {
			img {
				width: 35px;
				height: 20px;
			}
		}

		.gjfwXlDw {
			position: absolute;
			bottom: -200px;
			left: 0;
			width: 100%;
			height: 182px;
			background: #FFFFFF;
			box-shadow: 0px 1px 6px 0px rgba(39, 39, 39, 0.2);
			border-radius: 10px;
			overflow-y: auto;
			padding: 10px 30px;
			box-sizing: border-box;

			.gjfwXlDwFor {
				// font-size: 24px;
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #000000;
				height: 40px;
				display: flex;
				align-items: center;
			}

			.gjfwXlDwForXz {
				color: #1A2588;
			}
		}
	}

	.gjfwDdian {
		display: flex;
		align-items: center;
		width: 1200px;
		height: 400px;
		background: #fafafa;
		padding: 48px 128px;
		box-sizing: border-box;

		.gjfwDdianLeft {
			flex: 1;
			width: 0;
			height: 100%;
			display: flex;
			flex-direction: column;

			.gjfwDdianLeftOne {
				// font-size: 36px;
				font-size: 30px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #6A6A6A;
				flex: 1;
			}

			.gjfwDdianLeftTwo {
				font-size: 24px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #000000;
				margin-bottom: 35px;
			}

			.gjfwDdianLeftThree {
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #4C4C4C;
				margin-bottom: 23px;
			}

			.gjfwDdianLeftFour {
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #4C4C4C;
			}
		}

		.gjfwDdianRight {
			margin-left: 30px;

			img {
				width: 400px;
				height: 305px;
			}
		}
	}
}

@media screen and (max-width:1200px) {
	.gjfw {
		width: 100% !important;
		// background-color: green;
		margin-top: 10px !important;
		height: auto !important;
		padding: 0 30px !important;
		box-sizing: border-box !important;

		.gjfwTil {
			font-size: 28px !important;
			margin-bottom: 10px !important;
		}

		.gjfwXl {
			width: 100% !important;
			margin-bottom: 0 !important;

			.gjfwXlName {
				font-size: 20px !important;
			}

			.gjfwXlJt {
				img {
					width: 20px !important;
					height: 10px !important;
				}
			}
		}
	}
	.gjfwDdian {
			width: 100% !important;
			// background-color: pink !important;
			padding: 0 !important;
			height: auto !important; 
			display: block !important; 
			margin-top: 10px !important;
			.gjfwDdianLeft{
				height: auto !important;
				width: 100% !important;
				padding: 0 30px !important;
				box-sizing: border-box !important; 
				.gjfwDdianLeftOne{
					height: auto !important; 
					font-size: 25px !important;
					margin-bottom: 10px !important;
				}
				.gjfwDdianLeftTwo{
					font-size: 20px !important;
					margin-bottom: 10px !important;
				}
				.gjfwDdianLeftThree{
					font-size: 14px !important;
					margin-bottom: 10px !important;
				}
			}
		
			.gjfwDdianRight {
				width: 100%;
				margin: 0 !important;
				margin-top: 10px !important;
				padding: 0 30px !important;
				box-sizing: border-box !important; 
				img {
					width: 100% !important;
					height: auto !important;
				}
			}
		}
}
</style>